// NPM
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { omitBy, isNull, isEmpty } from "lodash";
import errorHandler from "Utils/error-handler";

// ANT COMPONENTS
import { Col, Row, InputNumber } from "antd";
import { AlertBox, Button, SelectInput } from "@life-line-lab/components-react";

//SCHEMAS
import { ArchiveSettingsSchema } from "./archive-settings-validation";

const compareItem = (type, archiveSettings) => {
  switch (type) {
    case "ORDER":
      return +archiveSettings?.noOfOrders;
    case "INCIDENT_REPORT":
      return +archiveSettings?.noOfIncidentReports;
    default:
      return null;
  }
};

const ArchiveSettings = ({ onSubmit, onCancel, archiveSettings, type = "ORDER" }) => {
  const initialInput = {
    noOfItems: 10,
    frequency: "",
  };

  const { t } = useTranslation();

  const initialError = {};
  const [input, setInput] = useState(initialInput);
  const [error, setError] = useState<any>(initialError);

  useEffect(() => {
    if (!isEmpty(archiveSettings)) {
      const noOfItems = compareItem(type, archiveSettings);
      // BE noOfOrders is type string, but FE accepts number
      setInput({
        ...archiveSettings,
        noOfItems: noOfItems,
      });
    }
  }, [archiveSettings]);

  const handleSelectChange = (value: string | string[] | {}, name: string) => {
    setError(initialError);
    setInput({ ...input, [name]: value });
  };

  const handleSubmit = () => {
    try {
      const valInput = {
        ...input,
      };
      const value = ArchiveSettingsSchema.validateSync(omitBy(valInput, isNull), {
        strict: false,
        abortEarly: true,
        stripUnknown: true,
      });
      onSubmit(value);
      onCancel();
    } catch (err) {
      console.log(err);
      const { path, value }: any = errorHandler.validation(err);
      setError({ ...error, [path]: t(`${value}`, { field: t(`label.${path}`) }) });
    }
  };

  return (
    <>
      <Row className="archive-settings-modal" gutter={[0, 24]}>
        <Col span={24}>
          <div className="modal-content-title">{t("label.archiveSettings")}</div>
          <span>{t("label.archivesDesc")}</span>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 8]} align="middle">
            <Col span={6} className="label">
              {t("label.archiveAfter")}:
            </Col>
            <Col span={18}>
              <SelectInput
                showSearch
                options={[
                  {
                    label: t("label.weekly"),
                    value: "WEEKLY",
                  },
                  {
                    label: t("label.monthly"),
                    value: "MONTHLY",
                  },
                  {
                    label: t("label.yearly"),
                    value: "YEARLY",
                  },
                ]}
                name="frequency"
                isRequired={true}
                placeholder={t("txt.selectDuration")}
                isReadonly={false}
                value={input.frequency}
                onChange={(value) => handleSelectChange(value, "frequency")}
              />
              <AlertBox text={error.duration} />
            </Col>
            <Col span={6} className="label">
              {t("label.numberOfItems")}
            </Col>
            <Col span={18}>
              <InputNumber
                min={1}
                name="noOfItems"
                style={{ width: "100%" }}
                placeholder={t("txt.noOfOrdersToArchive")}
                onChange={(value) => handleSelectChange(value, "noOfItems")}
                value={input.noOfItems}
              />
              <AlertBox text={error.number} />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <div className="mt-30 right modal-end-button">
            <Button
              type={"primary"}
              label={t("action.set")}
              onClick={() => {
                handleSubmit();
              }}
            />
            <Button
              className="cancel-btn"
              type={"default"}
              label={t("action.cancel")}
              onClick={() => {
                onCancel();
              }}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ArchiveSettings;
